import React from "react";
import Nav from "./Navigation.js";

const getShuffledPuzzle = () => {
  const values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const randnumforgame = Math.floor(Math.random()* 9) + 1;
  values.splice(randnumforgame, 1)
  const rowOne = [],
    rowTwo = [],
    rowThree = [];

  while (values.length) {
    const random = Math.floor(Math.random() * values.length);

    if (rowOne.length < 3) {
      rowOne.push(values.splice(random, 1)[0]);
    } else if (rowTwo.length < 3) {
      rowTwo.push(values.splice(random, 1)[0]);
    } else {
      rowThree.push(values.splice(random, 1)[0]);
    }
  }

  return [rowOne, rowTwo, rowThree];
};

const flattenArray = (arr) => {
  return arr.reduce((flatArr, subArr) => flatArr.concat(subArr), []);
};

const getInversionsCount = (arr) => {
  arr = flattenArray(arr).filter((n) => n !== 0);

  const inversions = [];

  for (let i = 0; i < arr.length - 1; i++) {
    const currentValue = arr[i];
    const currentInversions = arr.filter(
      (val, j) => i < j && val < currentValue
    );
    inversions.push(currentInversions.length);
  }

  const inversionsCount = inversions.reduce((total, val) => total + val, 0);

  return inversionsCount;
};

const isSolvable = (puzzle) => {
  return getInversionsCount(puzzle) % 2 === 0;
};

const getPuzzle = () => {
  let puzzle = getShuffledPuzzle();

  while (!isSolvable(puzzle)) {
    puzzle = getShuffledPuzzle();
  }

  return puzzle;
};

export default function App() {
  const [puzzle, setPuzzle] = React.useState([]);
  const [complete, setComplete] = React.useState(false);
  const [moves, setMoves] = React.useState(0);

  React.useEffect(() => {
    setPuzzle(getPuzzle());
  }, []);

  const movePiece = (x, y) => {
    if (!complete) {
      if (checkNeighbours(x, y) || checkNeighbours(x, y, 2)) {
        const emptySlot = checkNeighbours(x, y) || checkNeighbours(x, y, 2);

        const newPuzzle = puzzle.map((row) => row.slice());

        if (x === emptySlot.x && y < emptySlot.y) {
          newPuzzle[emptySlot.x][emptySlot.y] = puzzle[x][y + 1];
          newPuzzle[x][y + 1] = newPuzzle[x][y];
          newPuzzle[x][y] = 0;
        } else if (x === emptySlot.x && y > emptySlot.y) {
          newPuzzle[emptySlot.x][emptySlot.y] = puzzle[x][y - 1];
          newPuzzle[x][y - 1] = newPuzzle[x][y];
          newPuzzle[x][y] = 0;
        }

        if (y === emptySlot.y && x < emptySlot.x) {
          newPuzzle[emptySlot.x][emptySlot.y] = puzzle[x + 1][y];
          newPuzzle[x + 1][y] = newPuzzle[x][y];
          newPuzzle[x][y] = 0;
        } else if (y === emptySlot.y && x > emptySlot.x) {
          newPuzzle[emptySlot.x][emptySlot.y] = puzzle[x - 1][y];
          newPuzzle[x - 1][y] = newPuzzle[x][y];
          newPuzzle[x][y] = 0;
        }

        setPuzzle(newPuzzle);

        setMoves(moves + 1);

        checkCompletion(newPuzzle);
      }
    }
  };

  const checkCompletion = (puzzle) => {
    let flatArray =flattenArray(puzzle).join("")
    let solution = "123456789"
    let count = 0
    for (let i = 0; i < 9; i++){
      if (flatArray[i] === solution[i]){
        count++
      }
    }
    if (count === 8) {
      setComplete(true);
    }
  };

  const checkNeighbours = (x, y, d = 1) => {
    const neighbours = [];

    if (puzzle[x][y] !== 0) {
      neighbours.push(
        puzzle[x - d] && puzzle[x - d][y] === 0 && { x: x - d, y: y }
      );
      neighbours.push(puzzle[x][y + d] === 0 && { x: x, y: y + d });
      neighbours.push(
        puzzle[x + d] && puzzle[x + d][y] === 0 && { x: x + d, y: y }
      );
      neighbours.push(puzzle[x][y - d] === 0 && { x: x, y: y - d });
    }

    const emptySlot = neighbours.find((el) => typeof el === "object");

    return emptySlot;
  };

  const resetPuzzle = () => {
    setComplete(false);
    setPuzzle(getPuzzle());
    setMoves(0);
  };

  return (
    <div className="App">
      <Nav />
      {<h3 className="text-white">Moves: {moves}</h3>}
      <div
        style={{
          display: "inline-block",
          backgroundColor: "darkgray",
          border: `5px solid ${complete ? "black" : "gray"}`,
          borderRadius: 5,
          padding: 5,
        }}
      >
        {puzzle.map((row, i) => (
          <div
            key={i}
            style={{
              display: "flex",
            }}
          >
            {row.map((col, j) => {
              const color = col === 0 ? "transparent" : "lightgray";
              return (
                <div
                  key={`${i}-${j}`}
                  onClick={() => movePiece(i, j)}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 77,
                    height: 77,
                    margin: 2,
                    backgroundColor: color,
                    borderRadius: 5,
                    cursor: complete ? "not-allowed" : "pointer",
                    userSelect: "none",
                  }}
                >
                  <span style={{ fontSize: "2rem", fontWeight: "bold" }}>
                    {col !== 0 && col}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
      {complete && (
        <div className="text-green-500 font-bold">
          <div>YOU WON!!</div>
          <button
          className="border rounded pl-2 pr-2"
            onClick={() => {
              resetPuzzle();
            }}
          >
            Play Again
          </button>
        </div>
      )}
    </div>
  );
}



// import React, { useState, useEffect } from "react";

// const Game = () => {
//   const [lights, setLights] = useState({
//     light1: false,
//     light2: false,
//     light3: false,
//     light4: false,
//     light5: false,
//   });

//   const [leverLightMap, setLeverLightMap] = useState({});

//   // Define the shuffleArray function
//   const shuffleArray = (array) => {
//     for (let i = array.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [array[i], array[j]] = [array[j], array[i]];
//     }
//     return array;
//   };

//   useEffect(() => {
//     // Create a shuffled array of lights
//     const lightsArray = Object.keys(lights);
//     const shuffledLights = shuffleArray(lightsArray);

//     // Assign shuffled lights to levers
//     const newLeverLightMap = {};
//     const numLevers = Math.min(shuffledLights.length, 5);
//     for (let i = 0; i < numLevers; i++) {
//       newLeverLightMap[`lever${i + 1}`] = shuffledLights.slice(0, i + 1);
//     }
//     setLeverLightMap(newLeverLightMap);
//   }, []); // Run this effect only once on component mount

//   const toggleLight = (light) => {
//     setLights((prevLights) => ({
//       ...prevLights,
//       [light]: !prevLights[light],
//     }));
//   };

//   const handleLeverClick = (lever) => {
//     const lightsToToggle = leverLightMap[lever];
//     lightsToToggle.forEach((light) => toggleLight(light));

//     // Check if all lights are lit
//     const allLightsLit = Object.values(lights).every((light) => light);
//     if (allLightsLit) {
//       alert("Congratulations! You lit up all the lights!");
//       resetGame();
//     }
//   };

//   const resetGame = () => {
//     // Reset all lights
//     setLights({
//       light1: false,
//       light2: false,
//       light3: false,
//       light4: false,
//       light5: false,
//     });

//     // Shuffle lights and reassign to levers
//     const lightsArray = Object.keys(lights);
//     const shuffledLights = shuffleArray(lightsArray);
//     const newLeverLightMap = {};
//     const numLevers = Math.min(shuffledLights.length, 5);
//     for (let i = 0; i < numLevers; i++) {
//       newLeverLightMap[`lever${i + 1}`] = shuffledLights.slice(0, i + 1);
//     }
//     setLeverLightMap(newLeverLightMap);
//   };

//   return (
//     <div className="flex flex-col items-center justify-center space-y-4">
//       <div className="lights flex">
//         {Object.keys(lights).map((light, index) => (
//           <div
//             key={index}
//             className={`w-4 h-4 bg-gray-300 rounded-full ${
//               lights[light] ? "bg-yellow-400" : ""
//             }`}
//           />
//         ))}
//       </div>
//       <div className="levers flex space-x-2">
//         {Object.keys(leverLightMap).map((lever, index) => (
//           <button
//             key={index}
//             className="px-4 py-2 bg-blue-500 text-white rounded"
//             onClick={() => handleLeverClick(lever)}
//           >
//             {lever}
//           </button>
//         ))}
//       </div>
//       <button
//         className="px-4 py-2 bg-red-500 text-white rounded"
//         onClick={resetGame}
//       >
//         Reset
//       </button>
//     </div>
//   );
// };

// export default Game;
